module.exports = __webpack_public_path__ + "assets/img/9_101.3243c0da.jpg";